// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36W_c","inner":"Footer_inner__14Boq","nextIcon":"Footer_nextIcon__2fBGO","innerLeft":"Footer_innerLeft__19eRY"};